export function copyElementContents(el) {
  // from https://stackoverflow.com/a/42210996/490592
  var body = document.body, range, sel
  if (document.createRange && window.getSelection) {
    range = document.createRange()
    sel = window.getSelection()
    sel.removeAllRanges()
    try {
      range.selectNodeContents(el)
      sel.addRange(range)
    } catch (e) {
      range.selectNode(el)
      sel.addRange(range)
    }
    document.execCommand("copy")

  } else if (body.createTextRange) {
    range = body.createTextRange()
    range.moveToElementText(el)
    range.select()
    range.execCommand("Copy")
  }
}
